<template>
  <div class="home" :key="`key_${contributions.length}`">
    <div class="header">
      <img alt="SMASK" class="logo" src="../assets/images/riks-logo.png">
    </div>

    <div class="scoreboard" v-if="settings">
      <div class="bidrag" :style="{ 'font-size': `${currentFontSize}rem` }" v-for="(contribution, index) in sortedContributions" :key="contribution.id">
        <div class="placement" v-if="sum(contribution.points) === 0">-.</div>
        <div class="placement" v-else>{{index + 1}}.</div>
        <div class="name">{{contribution.name}}</div>
        <div class="points">{{sum(contribution.points)}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import { firebase } from "@/initializers/firebase"
  import orderBy from "lodash/orderBy"
  import sum from "lodash/sum"

  export default {
    name: "home",
    data() {
      return {
        settings: null,
        contributions: [],
        sum: sum,
        fontSize: 4.375
      }
    },
    computed: {
      sortedContributions() {
        return orderBy(this.contributions, [(bidrag) => sum(bidrag.points), "name"], ["desc", "asc"])
      },
      currentFontSize() {
        const settingSize = parseFloat(this.settings.scoreboardFontSize)
        return isNaN(settingSize) ? this.fontSize : settingSize
      }
    },
    async mounted() {
      await this.$bind("settings", firebase.firestore().collection(`application`).doc(`settings`))
      await this.$bind("contributions", firebase.firestore().collection(`contributions`))
    }
  }
</script>

<style lang="scss" scoped>
  .fade {
    opacity: 0 !important;
    transition: opacity .3s ease-in;
  }

  .home {
    width: 100%;
    height: 100%;
  }

  .header {
    margin: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    .logo {
      width: auto;
      height: 150px;
    }
  }

  .scoreboard {

  }

  .bidrag {
    transition: opacity .3s ease-in;
    opacity: 1;
    display: flex;
    padding-left: 80px;
    padding-right: 80px;
    // font-size: 4.375rem;
    margin-top: 25px;

    .name {
      flex: 1;
      padding-left: 30px;
    }
  }
</style>